import { Email } from "@/shared/value-objects/email.vo";
import type { UserListItemResponseDto } from "@/spz-api/model";
import { UserAccountType } from "./user-account-type.model";
import { UserStatus } from "./user-status.model";

export interface UserListItem {
  id: string;
  firstName: string;
  lastName: string;
  email: Email;
  lastActivity: Date | null;
  accountType: UserAccountType;
  status: UserStatus;
}

export class UserMapper {
  static toListItem(user: UserListItemResponseDto): UserListItem {
    return {
      id: String(user.id),
      firstName: user.firstName ?? "",
      lastName: user.lastName ?? "",
      email: Email.create(user.email),
      lastActivity: user.lastActivity ? new Date(user.lastActivity) : null,
      accountType: UserAccountType.fromApi(user.accountType),
      status: UserStatus.fromApi(user.status),
    };
  }
  static toListItems(dtos: UserListItemResponseDto[]): UserListItem[] {
    return dtos.map(UserMapper.toListItem);
  }
}
